import script from "./nav.vue?vue&type=script&setup=true&lang=js"
export * from "./nav.vue?vue&type=script&setup=true&lang=js"

import "./nav.vue?vue&type=style&index=0&id=aab5b570&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aab5b570"]])

export default __exports__